// Lokale Sicherung von Beitragsentwürfen (localStorage), damit Text bei
// Token-Ablauf/Seiten-Reload nicht verloren geht. Dateianhänge (Blobs) lassen
// sich nicht speichern und werden nur als Hinweis (Dateiname) mitgeführt.

const PREFIX = 'nahs_entwurf_'

export function entwurfKey(modentry, fbnews) {
    const id = modentry === 'new' ? 'neu' + (fbnews ? '_fb' : '') : modentry?._id
    return id ? PREFIX + id : null
}

export function entwurfSpeichern(key, entry) {
    if (!key) return
    const inhalt = {
        title: entry.title || '',
        start: entry.start || '',
        end: entry.end || '',
        groups: entry.groups || [],
        html: entry.html || '',
        anhaenge: (entry.files || []).filter(f => !f._id && f.blob?.name).map(f => f.blob.name),
        gespeichert: new Date().toISOString(),
    }
    try { localStorage.setItem(key, JSON.stringify(inhalt)) } catch (e) { /* Speicher nicht verfügbar */ }
}

export function entwurfLaden(key) {
    if (!key) return null
    try {
        const roh = localStorage.getItem(key)
        return roh ? JSON.parse(roh) : null
    } catch (e) {
        return null
    }
}

export function entwurfLoeschen(key) {
    if (!key) return
    try { localStorage.removeItem(key) } catch (e) { /* ignorieren */ }
}

// Ein Entwurf lohnt die Wiederherstellung nur, wenn er sich vom geladenen Stand unterscheidet
// und überhaupt Inhalt hat (leerer Quill-Editor liefert '<p><br></p>').
export function entwurfRelevant(entwurf, entry) {
    if (!entwurf) return false
    const leer = h => !h || h.replace(/<[^>]*>/g, '').trim() === ''
    if (leer(entwurf.html) && !entwurf.title?.trim()) return false
    return entwurf.html !== (entry.html || '') || entwurf.title !== (entry.title || '')
}
